var _slicedToArray = require("/vercel/workpath0/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _require = require('ethers/utils/bignumber'),
    bigNumberify = _require.bigNumberify;

var RLP = require('ethers/utils/rlp');

module.exports = function decodeTx(raw_tx) {
  var decoded_tx = RLP.decode(raw_tx);

  var _decoded_tx = _slicedToArray(decoded_tx, 9),
      raw_nonce = _decoded_tx[0],
      raw_gasPrice = _decoded_tx[1],
      raw_gasLimit = _decoded_tx[2],
      raw_to = _decoded_tx[3],
      raw_value = _decoded_tx[4],
      raw_data = _decoded_tx[5],
      raw_v = _decoded_tx[6],
      raw_r = _decoded_tx[7],
      raw_s = _decoded_tx[8];

  var transaction = {
    nonce: bigNumberify(raw_nonce).toNumber(),
    gasPrice: bigNumberify(raw_gasPrice),
    gasLimit: bigNumberify(raw_gasLimit),
    to: raw_to,
    value: bigNumberify(raw_value),
    data: raw_data,
    v: bigNumberify(raw_v).toNumber(),
    r: raw_r,
    s: raw_s
  };
  if (transaction.to == '0x') delete transaction.to;
  return transaction;
};